import { defineComponent as _defineComponent } from 'vue'
import {ScheduleCostType, ScheduleRow} from '@/components/calculator/schedule/Schedule';
import {useScheduleStore} from '@/components/calculator/services/ScheduleStore';
import {sum} from 'lodash-es';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleTableRow',
  props: {
    item: null,
    print: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  item: ScheduleRow;
  print?: boolean;
}




const store = useScheduleStore();

const convertMonthToYear = (month: number): number => Math.ceil(month / 12);

const additionalCostsSum = (item: ScheduleRow): number => {
  return sum(item.additionalCosts?.map(cost => cost.fee)) || 0;
};

const monthlyCostSum = (item: ScheduleRow): number => {
  return item.monthlyFee + additionalCostsSum(item);
}

const getKeyByValue = (value: string): keyof typeof ScheduleCostType | undefined => {
  return Object.keys(ScheduleCostType).find((key) => ScheduleCostType[key] === value) as keyof typeof ScheduleCostType | undefined;
}

return { __sfc: true,props, store, convertMonthToYear, additionalCostsSum, monthlyCostSum, getKeyByValue }
}

})